// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { getCurrentProductBand } from '../../../common/calculate'
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function CoreCountryCountRow() {
   const state = useQuoteContext()
   const { getString } = state

   let countryMultiplier = getCurrentProductBand(
      state.product_list,
      state.hrImplementationCosts.productCode,
      state.productCoreEECount,
   )['CountryMultiplier']
   if (
      countryMultiplier != undefined &&
      countryMultiplier != null &&
      countryMultiplier != 0
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.CoreCountryCountRow.ProductName')}
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  min={0}
                  placeholder={'0'}
                  value={
                     state.coreCountryCount <= 0
                        ? ''
                        : state.coreCountryCount.toString()
                  }
                  onChange={(e) =>
                     state.setCoreCountryCount(Number(e.target.value))
                  }
                  onBlur={() =>
                     state.setCoreCountryCount(
                        state.coreCountryCount < 1
                           ? 0
                           : Math.floor(state.coreCountryCount),
                     )
                  }
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {'extraCountryCost' in state.hrImplementationCosts &&
                  formatFloatAsCurrencySymbol(
                     state.hrImplementationCosts.extraCountryCost,
                     state.currencyObject,
                  )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
